import { api } from './api';

export default async function fetchForecastGeneralDetailData({
	accessToken,
	year,
	countryId,
	productId,
	marketplaceId,
}) {
	const res = await api.get('/GetForecastDataHistoryDetail', {
		params: {
			countryId,
			limit: 100,
			offset: 0,
			year: year ? year : 0,
			productId,
			marketplace_id: marketplaceId,
		},
		headers: {
			Authorization: `Bearer ${accessToken}`,
			accept: '*/*',
		},
	});

	const items = res?.data?.data || [];
	const count = res?.data?.count;

	return {
		items: items.map((item) => ({
			...item,
			id: `${item?.created_at}-${item?.country_id}-${item?.product_id}-${item?.category_id}-${item?.marketplace_id}`,
		})),
		count,
	};
}
